 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		70: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","6":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","7":"buybox~promotion-products-lazy~quick-view","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","10":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","11":"add-to-list-drawer~orange-lens","12":"bath-renovation~consumer-card-messaging","13":"buybox~quick-view","14":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","17":"ratings-and-reviews-mobile","20":"StoreLayout","21":"add-to-list-drawer","22":"aisle-bay","23":"augmented-reality","24":"bath-renovation","25":"breadcrumbs","26":"browse-and-search","27":"browse-and-search-mobile","28":"buybox","29":"calculator-pipcalculator","30":"collections","31":"collections-mobile","32":"common","33":"compare","34":"consumer-card-messaging","35":"customer-image-overlay","36":"drawer","37":"emt-generated-content","38":"emt-links","39":"fbr","40":"global-custom-configurator","41":"hammerjs","43":"home","44":"magic-apron","45":"measurement-guide","46":"measurement-guide-overlay-content","47":"media-gallery-filmstrip-mobile","48":"media-gallery-overlay","49":"media-gallery-overlay-mobile","50":"message-types","51":"orange-lens","52":"order-sample","53":"order-sample-drawer","54":"overlay","55":"paint-reorder","56":"paint-reorder-mobile","57":"pep","58":"pep-mobile","59":"product","60":"product-mobile","61":"product-overview","62":"promotion-products-lazy","63":"question","64":"questions-and-answers","65":"quick-view","66":"ratings-and-reviews","67":"ratings-and-reviews-desktop","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"video-player","82":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"336d225a7f1cfe7bd4ec","1":"1e7a91ae5465878678c0","2":"aed31282d0f5f44fc868","3":"66ffc0584eedcd893d63","4":"9d77b6873ddb3c507c81","5":"55f4f3075910602add44","6":"cf15587c27006df44977","7":"edb52f5c2b28f451b454","8":"291da266f6fd4297d22e","9":"878bad5f956f08f28584","10":"9b03f137121f3aeda52e","11":"c1fde73bcc565f87f904","12":"fa2d15ca91e489ef6f95","13":"b9f97ca1247df2cbec90","14":"83d26637545b13661e24","15":"2e0cf00c1d45dc4a292a","16":"26380cafc4e43dda4460","17":"423327f9daa6df7346b9","18":"158e54c4ff033082bcc7","19":"fbe86b0c15858dc4ad43","20":"5538a388628ff126825e","21":"153dac9b28eab6951175","22":"27b8a49aa8ce29b5e529","23":"00eb41a85c060504f742","24":"2013ecb06131ad6e760d","25":"543422502d490954113b","26":"fbca726dd358be12fa0d","27":"0effca9bb097bd6d7006","28":"670bbbcd17e7603aa6b4","29":"02d0746202ea07be77e6","30":"35a01d7329a07ce06168","31":"5707d9031e5c5fdd31f2","32":"9c7090aba253067ee1e5","33":"487983d21bc1ea9ad76f","34":"36789d2d56ad52bc2b9e","35":"1629641150d3a32c9087","36":"f60661ccb0aa55912c1f","37":"eab0a97658634a729342","38":"ab5880b66ef12407057c","39":"73c7007c67ef0496cda7","40":"b066522e6371f2264081","41":"b88117458ec0ad7bc957","43":"be242762005e2e8254a0","44":"0e15491acd2b51aa2cb5","45":"d09467e98bc1982f1023","46":"0c876596de4f922d6f30","47":"8e30389d01fc73ce0c11","48":"369b5dfb2255e652bd5f","49":"0eababaa03244a6ce1ca","50":"10871469bc6d63594423","51":"05009bfa79655638c0d6","52":"f9ef398f4bbc73487a7b","53":"679d9b8b84862fe1d226","54":"a4d3d59d99504c0dbcad","55":"72b9e4a69d198c3066e2","56":"cd518a5cb638a4471731","57":"f322feb03e940170865e","58":"97b035e91615cac6b34c","59":"d8f41056ef55e47569cb","60":"f4769363e1bfcc86ec50","61":"615272c91c7bcba25084","62":"c580f12b374ea46a2206","63":"e3365b866daa9f8773f1","64":"f6bf5ae0c9092f1edb67","65":"7c4ac80344905b46fdaf","66":"5534649f550f9bb0f740","67":"5f5026c8c508140a2401","68":"30011b4669903c9a41c4","69":"077b75b6b4ae0a276550","71":"7acca59feceb42588aca","72":"c8e09e53d44d01837ebf","73":"554c121b51362d0b456a","74":"b89a595088c8957e5a26","75":"745072234619c667c6a4","76":"c8051ec8d779b4f1f728","77":"98915005bbd1b5d2b1dd","78":"5890765ba92c20d44097","79":"4cc6723f5474202d232c","81":"f776e2d53c5d593ad5de","82":"3e89cb57f0ede0576ee0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"13":1,"15":1,"16":1,"17":1,"22":1,"26":1,"27":1,"28":1,"30":1,"31":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"40":1,"44":1,"47":1,"48":1,"49":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"64":1,"65":1,"66":1,"73":1,"75":1,"76":1,"77":1,"78":1,"79":1,"82":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","6":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","7":"buybox~promotion-products-lazy~quick-view","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","10":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","11":"add-to-list-drawer~orange-lens","12":"bath-renovation~consumer-card-messaging","13":"buybox~quick-view","14":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","17":"ratings-and-reviews-mobile","20":"StoreLayout","21":"add-to-list-drawer","22":"aisle-bay","23":"augmented-reality","24":"bath-renovation","25":"breadcrumbs","26":"browse-and-search","27":"browse-and-search-mobile","28":"buybox","29":"calculator-pipcalculator","30":"collections","31":"collections-mobile","32":"common","33":"compare","34":"consumer-card-messaging","35":"customer-image-overlay","36":"drawer","37":"emt-generated-content","38":"emt-links","39":"fbr","40":"global-custom-configurator","41":"hammerjs","43":"home","44":"magic-apron","45":"measurement-guide","46":"measurement-guide-overlay-content","47":"media-gallery-filmstrip-mobile","48":"media-gallery-overlay","49":"media-gallery-overlay-mobile","50":"message-types","51":"orange-lens","52":"order-sample","53":"order-sample-drawer","54":"overlay","55":"paint-reorder","56":"paint-reorder-mobile","57":"pep","58":"pep-mobile","59":"product","60":"product-mobile","61":"product-overview","62":"promotion-products-lazy","63":"question","64":"questions-and-answers","65":"quick-view","66":"ratings-and-reviews","67":"ratings-and-reviews-desktop","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"video-player","82":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"46d0ac7da3db8adb1367","1":"66bba79b70e3924b990e","2":"31d6cfe0d16ae931b73c","3":"aaa0137a65d448ed5f64","4":"7647b1510da5618b37af","5":"89d9163eeb30e835d559","6":"1955189c596e6d9ade5e","7":"d6905e41bc7aa3f68e43","8":"59d72f4e8c0806257828","9":"5be74f9388ceb53b19a6","10":"7c2eed0c18c49e42c517","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"95a5994acce6e02a6b07","14":"31d6cfe0d16ae931b73c","15":"19391484b2828e6b673c","16":"2a09750166a70e474555","17":"2ade42f7647d0b013747","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"d94b956aa532c1a50c65","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"96c3f664169e9b48c9f2","27":"838a3dcb3f28f3765d8d","28":"4dff0eff57ce1f73df40","29":"31d6cfe0d16ae931b73c","30":"b2ddf978d2543bdff784","31":"46d564885c9acf08eb20","32":"31d6cfe0d16ae931b73c","33":"ffe192ad5912a5ec682f","34":"c07ce9ab259c3f695942","35":"c466036523aec2558c34","36":"fc73174b407ad863c497","37":"b49004ddac99adec2224","38":"31d6cfe0d16ae931b73c","39":"88e24c7aafcf93ae6cc6","40":"1a5562a08d12f7682989","41":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"ceebf150d8a696023a14","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"e07956ac4ef9facbea2e","48":"7013f93350fef54e51c5","49":"75d310264ecdef1a204b","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"348b6dde6f988edf4f22","55":"b50a3f9a7a977873c20c","56":"f3a72da947e227c88614","57":"75a826a75b75e024c50b","58":"53bae0c64bb8bee5edb4","59":"3edebe61e5f5cbd103e3","60":"fbcd1d7e22c3dd49b5f8","61":"be155bb5d11dacdc4bb8","62":"c7e4a3cb02089bb4d052","63":"31d6cfe0d16ae931b73c","64":"d70c859b20e57c1599c5","65":"3fb67ef60d9f4cf19fb8","66":"2405e76b2c92f2f21947","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"453dfc2640779a848cc6","74":"31d6cfe0d16ae931b73c","75":"6c6bdd949ddd0752832b","76":"922dbc8ed510a58afe20","77":"e518e335254638969e62","78":"fbae370640798a57513a","79":"05ba11d0a20efb76fea5","81":"31d6cfe0d16ae931b73c","82":"5512b06edf556d72360f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
